/*
 * @Author: syyoon@yongtrim.com 
 * @Date: 2018-08-07 11:40:32 
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2018-09-26 01:53:26
 */


import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ENV } from '../env/env';
import { TransService } from './trans.service';

@Injectable()
export class DonatorService {

  private url = `${ENV.SERVER_URL}/${ENV.API_PATH}/donators`;

  constructor(
    private transService: TransService,
    private http: HttpClient) {
  }

  createDonator(data) {
    return this.http.post(`${this.url}`, data);
  }

  getDonators(page: number, search?: string) {
    return this.http.get(`${this.url}?page=${page}&s=${search || ''}&lang=${this.transService.lang}`);
  }

  getDonator(id: string) {
    return this.http.get(`${this.url}/${id}?lang=${this.transService.lang}`);
  }

  updateDonator(id: string, data) {
    return this.http.put(`${this.url}/${id}?lang=${this.transService.lang}`, data);
  }

  deleteDonator(id: string) {
    return this.http.delete(`${this.url}/${id}?lang=${this.transService.lang}`);
  }
}



// WEBPACK FOOTER //
// ./src/services/donator.service.ts